import Image from "next/image";
import React, { InputHTMLAttributes } from "react";

import styles from "./input.module.scss";
import { Images } from "@/utils/constants/imageRelativePaths";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  className?: string;
  error?: string;
}

const Input = ({
  name,
  label,
  className = "",
  error = "",
  ...props
}: InputProps) => {
  return (
    <div className={`${styles.inputWrapper} ${className}`}>
      {label && <label htmlFor={name}>{label}</label>}
      <input id={name} name={name} {...props} />
      {error && (
        <div className={styles.error}>
          <Image src={Images.warningIcon} alt="warning" width={8} height={8} />{" "}
          {error}
        </div>
      )}
    </div>
  );
};

export default Input;
